export default "__VITE_ASSET__BHlX8EDh__"